import React from "react";
import PropTypes from "prop-types";
//import Loading from "components/Loading";

const PopupLimiteH = ({
    execActionConfirm = null,
    //popupLegalText = "",
    disponibleLHPop = null,
    horaLHPop = null,
    cantCupLHPop = null,
}) => {
    const handleConfirm = (event) => {
        execActionConfirm && execActionConfirm(event);
    };

    return (
        <div
            id="message-popup-terms"
            className="white-popup message-popup-simple"
        >
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-12">
                                <p className="text-center mb-4 red">
                                    <strong>Cupones Limitados</strong>
                                </p>
                                <div className="text-center mb-4">
                                    <>
                                        {disponibleLHPop > 0 && (
                                            <>
                                                <p>
                                                    Disfruta tu cupón, el código
                                                    de liberación caducará
                                                    dentro de{" "}
                                                    {horaLHPop} hora(s).
                                                </p>
                                                <br></br>
                                                <p>
                                                    Apresúrate que solo quedan
                                                    por canjear{" "}
                                                    {disponibleLHPop} cupon(es).
                                                    Recuerda que solo es válido
                                                    para los primeros{" "}
                                                    {cantCupLHPop} Clientes que realicen canjes
                                                    efectivos en tienda de este
                                                    producto.
                                                </p>
                                            </>
                                        )}
                                        {disponibleLHPop == 0 && (
                                            <p>
                                                Cupón no Disponible Se alcanzó
                                                la cantidad máxima de cupones
                                                canjeados para este producto.
                                            </p>
                                        )}
                                    </>
                                </div>
                                <div className="text-center">
                                    <a
                                        href="#"
                                        onClick={(event) =>
                                            handleConfirm(event)
                                        }
                                        className="btn"
                                    >
                                        Aceptar
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

PopupLimiteH.propTypes = {
    execActionConfirm: PropTypes.func,
    //popupLegalText: PropTypes.string,
    disponibleLHPop: PropTypes.number,
    horaLHPop: PropTypes.number,
    cantCupLHPop: PropTypes.number,
};
export default PopupLimiteH;
